/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_Product_DescriptionInputs */

const en_create_product_description = /** @type {(inputs: Create_Product_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a new coffee product to the catalog.`)
};

const es_create_product_description = /** @type {(inputs: Create_Product_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agrega un nuevo producto de cafe al catalogo.`)
};

/**
* | output |
* | --- |
* | "Add a new coffee product to the catalog." |
*
* @param {Create_Product_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const create_product_description = /** @type {((inputs?: Create_Product_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_Product_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_create_product_description(inputs)
	return es_create_product_description(inputs)
});